var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { PreliveOutrightBetButtonsWrap } from "../PreliveOutrightBetButtonsWrap";
let PreliveOutright = class PreliveOutright extends React.Component {
    constructor(props) {
        super(props);
        this.componentPrefix = "prelive-outright";
    }
    renderSelections() {
        const numberOfSelectionsToShow = Math.min(this.props.markets[0].selections.length, this.props.numberOfSelectionsToShow);
        return this.props.markets[0].selections.map((s, i) => {
            return i < numberOfSelectionsToShow &&
                React.createElement(PreliveOutrightBetButtonsWrap, { key: `${this.componentPrefix}__button-holder__${s.id}-${i}`, details: this.props, selection: this.props.markets[0].selections[i], componentPrefix: this.componentPrefix });
        });
    }
    shouldRenderViewAllBtn(selectionsCount, numberOfSelectionsToShow) {
        if (this.props.isDesktop) {
            return selectionsCount > numberOfSelectionsToShow;
        }
        return selectionsCount > numberOfSelectionsToShow || this.props.isExpanded;
    }
    render() {
        const selectionsCount = this.props.markets[0].selections.length;
        const numberOfSelectionsToShow = Math.min(selectionsCount, this.props.numberOfSelectionsToShow);
        return (React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__wrap`, "data-uat": `div-ev-list-${this.componentPrefix}-wrap` },
            this.renderSelections(),
            this.shouldRenderViewAllBtn(selectionsCount, numberOfSelectionsToShow) && this.props.children));
    }
};
PreliveOutright = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], PreliveOutright);
export { PreliveOutright };
//# sourceMappingURL=PreliveOutright.js.map